export enum NewsActionTypes {
  FETCH = '@news/fetch',
  FETCH_STARTED = '@news/fetch/started',
  FETCH_SUCCEED = '@news/fetch/succeed',
  FETCH_FAILED = '@news/fetch/failed',
}
